module.exports = __webpack_public_path__ + "static/media/emprel.70415076.png";